import {
  EffectAxis,
  MouseEffectConfig,
  MouseEffectParams,
  SchemaGroup,
} from '../../types';
import { axis, inverted } from '../baseParams';

export interface SpinMouse extends MouseEffectParams {
  axis: EffectAxis;
}

const name = 'SpinMouse';
const groups: SchemaGroup[] = ['mouse', 'animation'];

export const config: MouseEffectConfig<SpinMouse> = {
  name,
  groups,
  schema: {
    inverted: { ...inverted },
    axis: { ...axis },
  },
  hide: true,
} as const;

export const responsiveConfig: MouseEffectConfig<SpinMouse> = {
  name,
  groups,
  schema: {
    inverted: { ...inverted },
    axis: { ...axis },
  },
  hide: true,
} as const;
